var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCreateGroupRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1229_15386)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 50,
    height: 50,
    rx: 25,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9727 21.2197C32.1985 21.2197 34 23.0212 34 25.2471C34 26.6694 33.2564 27.9219 32.1436 28.6377C33.0441 28.9216 33.8687 29.381 34.5752 29.9756C35.0837 29.5263 35.6781 29.1745 36.3271 28.9375C35.5471 28.3578 35.0431 27.4288 35.043 26.3848C35.043 24.6215 36.4691 23.1944 38.2324 23.1943C39.9958 23.1943 41.4219 24.6214 41.4219 26.3848C41.4217 27.429 40.9121 28.3569 40.1367 28.9365C42.271 29.7133 43.789 31.76 43.7998 34.165V34.5244C43.7998 34.546 43.7894 34.5631 43.7783 34.5742C43.7673 34.5853 43.7501 34.5956 43.7285 34.5957H37.085C37.119 34.8796 37.1396 35.1726 37.1396 35.4658V35.8359C37.1395 37.4631 35.8225 38.7802 34.1953 38.7803H25.7617C24.1345 38.7803 22.8165 37.4632 22.8164 35.8359V35.4658C22.8164 35.1726 22.837 34.8796 22.8711 34.5957H16.2715C16.2499 34.5956 16.2327 34.5853 16.2217 34.5742C16.2106 34.5631 16.2002 34.546 16.2002 34.5244V34.165C16.2003 31.7657 17.723 29.7194 19.8564 28.9424C19.0764 28.3626 18.5723 27.4337 18.5723 26.3896C18.5723 24.6264 19.9985 23.2003 21.7617 23.2002C23.5251 23.2002 24.9511 24.6263 24.9512 26.3896C24.9512 27.4344 24.4419 28.3637 23.666 28.9434C24.3047 29.1752 24.8888 29.5212 25.3965 29.96C26.0972 29.3758 26.9112 28.9214 27.8008 28.6377C26.6834 27.9217 25.9453 26.669 25.9453 25.2471C25.9453 23.0267 27.7468 21.2198 29.9727 21.2197ZM29.9678 29.2803C29.9095 29.2803 29.8428 29.2798 29.7812 29.2744C26.4522 29.3729 23.7764 32.1148 23.7764 35.4658V35.8359C23.7765 36.9235 24.6624 37.8094 25.75 37.8096H34.1846C35.2722 37.8094 36.1581 36.9236 36.1582 35.8359V35.4658C36.1582 32.1147 33.4825 29.3728 30.1533 29.2744C30.0919 29.2798 30.0259 29.2803 29.9678 29.2803ZM37.9893 29.5752C36.9592 29.6312 36.0193 30.0236 35.2783 30.6504C36.0355 31.4883 36.5942 32.4964 36.8936 33.6201H42.79C42.5312 31.4251 40.7178 29.6966 38.4844 29.5752L38.2646 29.5684H38.2002L37.9893 29.5752ZM21.4941 29.5752C19.2606 29.6965 17.4474 31.425 17.1885 33.6201H23.041C23.3405 32.491 23.9094 31.4672 24.6719 30.6289C23.9359 30.0168 23.006 29.6256 21.9863 29.5742L21.7783 29.5684H21.7129L21.4941 29.5752ZM38.2324 24.1602C37.0086 24.1602 36.0137 25.1551 36.0137 26.3789C36.0137 27.5921 36.9818 28.5761 38.1895 28.5977H38.2754C39.478 28.5708 40.4511 27.5865 40.4512 26.3789C40.4512 25.155 39.4563 24.1602 38.2324 24.1602ZM21.7461 24.1602C20.5222 24.1602 19.5264 25.155 19.5264 26.3789C19.5264 27.5922 20.5006 28.5764 21.7031 28.5977H21.7881C22.9909 28.571 23.9648 27.5866 23.9648 26.3789C23.9648 25.1552 22.9698 24.1604 21.7461 24.1602ZM29.9619 22.1904C28.2755 22.1904 26.9053 23.5607 26.9053 25.2471C26.9053 26.8745 28.1845 28.2078 29.7852 28.2988H30.1387C31.7393 28.2078 33.0186 26.8745 33.0186 25.2471C33.0186 23.5607 31.6483 22.1904 29.9619 22.1904Z",
    fill: "#F8693E",
    stroke: "#F8693E",
    strokeWidth: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1229_15386",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.968627 0 0 0 0 0.419608 0 0 0 0 0.27451 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1229_15386"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1229_15386",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCreateGroupRed);
export default __webpack_public_path__ + "static/media/icCreateGroupRed.4b38d78b8b2127cd1d463260934e6946.svg";
export { ForwardRef as ReactComponent };